import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCrowdinComponent } from './simple-icons-crowdin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCrowdinComponent ],
    exports:      [ SimpleIconsCrowdinComponent ],
    bootstrap:    []
})
export class SimpleIconsCrowdinModule {}
